import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { userPreferencesReducer } from './user-preferences.reducer';
import { UserPreferencesEffects } from './user-preferences.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('userPreferences', userPreferencesReducer),
    EffectsModule.forFeature([UserPreferencesEffects])
  ]
})
export class UserPreferencesStateModule {}
